// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  FormatAttachments,
  FormatDateColumn,
} from './Formatters'

export default [{
  cellFormatter: FormatDateColumn,
  columnKey: 'createTimestamp',
  columnHeader: 'Date',
  columnWidth: '116px',
  sortable: true,
}, {
  columnKey: 'comment',
  columnHeader: 'Comments',
}, {
  columnKey: 'createUser',
  columnHeader: 'User',
  sortable: true,
}, {
  cellFormatter: FormatAttachments,
  columnKey: 'attachments',
  columnHeader: 'Attachments',
  columnWidth: '170px',
  sortable: true,
}]
